export const getProductionStageList = state => {
    return state.list
}

export const getProductionStageDataProps = state => {
    return state.props
}

export const getProductionStageAllList = state => {
    return state.all_list
} 



// WEBPACK FOOTER //
// ./src/store/modules/productionStage/getters.js